import { DatePipe } from '@angular/common';
import {
  Component,
  input,
  OnInit,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { Types } from 'shared-lib';
import { v4 } from 'uuid';
import { RelativeDatePipe } from '../../pipes';

@Component({
  selector: '[ui-user-list-item]',
  standalone: true,
  imports: [RelativeDatePipe],
  templateUrl: './user-list-item.component.html',
  styleUrl: './user-list-item.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class UserListItemComponent implements OnInit {
  name = input.required<string>();
  lastName = input.required<string>();
  roles = input<Types.ERole[] | undefined>();
  email = input<string | undefined>();
  createdAt = input.required<Date>();
  required = input(false);
  editable = input(false);
  mutable = input<boolean>(false);
  delete = output<number>();
  id = input.required<number>();

  uiId = v4();

  constructor() {}

  ngOnInit(): void {}

  onDelete(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.delete.emit(this.id());
  }
}
